/**
 * Cost Pool Endpoints
 */

export const apiPostCostPool = async (
  costPool: CostPoolCreateUpdate,
): Promise<AxiosResponse<CostPool>> => {
  return await userManagementAxiosInstance.post('cost_pools', costPool);
};

export const apiGetCostPools = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  search: string = '',
): Promise<AxiosResponse<PaginatedCostPool>> => {
  return await userManagementAxiosInstance.get(
    `cost_pools?limit=${limit}&offset=${offset}&name=${search}`,
  );
};

export const apiGetCostPool = async (id: string | number): Promise<AxiosResponse<CostPool>> => {
  return await userManagementAxiosInstance.get(`cost_pools/${id}`);
};

export const apiPutCostPool = async (
  costPool: CostPoolCreateUpdate,
): Promise<AxiosResponse<CostPool>> => {
  return await userManagementAxiosInstance.put(`cost_pools/${costPool.id}`, costPool);
};

export const apiDeleteCostPool = async (id: string | number): Promise<AxiosResponse<CostPool>> => {
  return await userManagementAxiosInstance.delete(`cost_pools/${id}`);
};
